class FiltersDrawer extends HTMLElement {
  constructor() {
    super();

    this.isMobile = window.matchMedia("(max-width: 749px)").matches;

    if (this.isMobile) {
      this.trigger = document.querySelector(".js-drawer-trigger");
      this.drawer = this.querySelector(".filters__drawer");
      this.close = this.querySelector(".js-drawer-close");
      this.header = document.querySelector(".header");
      this.html = document.querySelector("html");

      this.calculateHeight();
      this.addListeners();
    }
  }

  addListeners() {
    this.trigger.addEventListener("click", () => this.toggleDrawer());
    this.close.addEventListener("click", () => this.toggleDrawer());

    window.addEventListener("scroll", debounce(this.calculateHeight.bind(this), 200));
  }

  calculateHeight() {
    const announcement = document.querySelector(".usp-banner");
    const announcementHeight = window.scrollY > announcement.clientHeight ? 0 : announcement.clientHeight;
    const headerHeight = this.header.clientHeight;

    this.drawer.style.height = `${window.innerHeight - announcementHeight - headerHeight}px`;
    this.drawer.style.top = `${announcementHeight + headerHeight}px`;
  }

  toggleDrawer() {
    this.drawer.classList.toggle("filters__drawer--active");
    this.header.classList.toggle("header--background");
    this.html.classList.toggle("overflow-hidden");
  }
}

customElements.define("filters-drawer", FiltersDrawer);